export const LIMIT_CYCLE_MAP = {
  None: 'NO_INTERVAL',
  Daily: 'DAILY',
  Weekly: 'WEEKLY',
  Monthy: 'MONTHLY',
};

export const maxGasErrorMessage = 'Per user maximum cannot exceed global maximum.';
export const maxUserOpGasErrorMessage = 'Per User Operation maximum cannot exceed global maximum';
export const minGasError = 'The maximum amount must be at least 0.01 USD';
export const minUserOpError = 'The maximum amount must be at least 1';
